
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.882 7c1.133 0 2.102.408 2.908 1.224.807.816 1.21 1.797 1.21 2.943v1.666c0 1.146-.403 2.127-1.21 2.943-.806.816-1.775 1.224-2.908 1.224h-5.764c-1.75 0-3.003-.833-3.758-2.5-.24-.59-.36-1.146-.36-1.667v-1.666h2.47v1.666c0 .486.155.886.464 1.198.309.313.703.469 1.184.469h5.764c.48 0 .875-.156 1.184-.469.309-.312.463-.712.463-1.198v-1.666c0-.486-.154-.886-.463-1.198-.309-.313-.703-.469-1.184-.469h-.823a3.915 3.915 0 00-.566-1.354c-.275-.417-.532-.712-.772-.886L15.41 7h2.471zm-2.19 2.5c.205.52.308 1.076.308 1.667v1.666h-2.47v-1.666c0-.486-.155-.886-.464-1.198-.309-.313-.703-.469-1.184-.469H6.118c-.48 0-.875.156-1.184.469-.309.312-.463.712-.463 1.198v1.666c0 .486.154.886.463 1.198.309.313.703.469 1.184.469h.823c.103.486.292.937.566 1.354.275.417.532.712.772.886l.31.26H6.117c-1.133 0-2.102-.408-2.908-1.224C2.403 14.96 2 13.979 2 12.833v-1.666c0-1.146.403-2.127 1.21-2.943C4.016 7.408 4.985 7 6.118 7h5.764a4.05 4.05 0 012.29.703c.704.469 1.21 1.068 1.52 1.797z","fill":"#4788C6","fill-rule":"evenodd"}})])
          )
        }
      }
    